import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPeriscopeComponent } from './simple-icons-periscope.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPeriscopeComponent ],
    exports:      [ SimpleIconsPeriscopeComponent ],
    bootstrap:    []
})
export class SimpleIconsPeriscopeModule {}
